<template>
  <div class="text-center pt-2">
    <div class="v-pagination theme--light">
      <ul class="v-pagination__list">
        <li>
          <button 
            class="v-pagination__navigation v-pagination__navigation--prev"
            :class="{ 'v-pagination__navigation--disabled': currentPage === 1 }"
            @click="changePage(currentPage - 1)" 
            :disabled="currentPage === 1"
          >
            <i class="fas fa-angle-left"></i>
          </button>
        </li>
        
        <li v-for="page in visiblePages" :key="page">
          <button 
            class="v-pagination__item"
            :class="{ 'v-pagination__item--active': page === currentPage }"
            @click="changePage(page)"
          >
            {{ page }}
          </button>
        </li>
        
        <li>
          <button 
            class="v-pagination__navigation v-pagination__navigation--next"
            :class="{ 'v-pagination__navigation--disabled': currentPage === pageCount }"
            @click="changePage(currentPage + 1)" 
            :disabled="currentPage === pageCount"
          >
            <i class="fas fa-angle-right"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimplePagination',
  
  props: {
    currentPage: { type: Number, required: true },
    pageCount: { type: Number, required: true }
  },
  
  emits: ['page-change'],
  
  computed: {
    visiblePages() {
      const pages = [];
      const totalVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(totalVisible / 2));
      let end = Math.min(this.pageCount, start + totalVisible - 1);
      
      if (end - start + 1 < totalVisible) {
        start = Math.max(1, end - totalVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  },
  
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.pageCount && page !== this.currentPage) {
        this.$emit('page-change', page);
      }
    }
  }
}
</script>

<style scoped>
.v-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-pagination__list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}

.v-pagination__item,
.v-pagination__navigation {
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  margin: 0 2px;
  min-width: 32px;
  padding: 0 8px;
  text-decoration: none;
  transition: background-color 0.3s;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
}

.v-pagination__item:hover,
.v-pagination__navigation:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.v-pagination__item--active {
  background-color: #1976d2;
  color: white;
}

.v-pagination__item--active:hover {
  background-color: #1565c0;
}

.v-pagination__navigation--disabled {
  opacity: 0.26;
  cursor: default;
  pointer-events: none;
}

.v-pagination__navigation--disabled:hover {
  background-color: transparent;
}
</style>